<template>
  <v-menu
    ref="menu1"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :placeholder="libelle"
        dense
        filled
        hide-details
        append-icon="event"
        class="mt-0"
        v-bind="attrs"
        @change="updateDateISO"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dateISO"
      no-title
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    libelle: {
      type: String,
    },
    value: {
      // la date au format iso
      type: String,
    },
  },
  data() {
    const dateISO = this.value;

    return {
      dateISO,
      dateFormatted: this.formatDate(dateISO),
      menu: false,
    };
  },
  watch: {
    dateISO(newVal) {
      this.dateFormatted = this.formatDate(newVal);
      this.$emit('input', newVal);
      this.$emit('change', newVal);
    },
  },
  methods: {
    updateDateISO() {
      this.dateISO = this.parseDate(this.dateFormatted);
    },
    formatDate(isoDate) {
      if (!isoDate) return null;

      return moment(isoDate).format('DD/MM/YYYY');
    },
    parseDate(texteDate) {
      if (!texteDate) return null;

      return moment(texteDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
  },
};
</script>
